import { RootState } from "../types";

export const getSupport = (state: RootState) => state.support